import '.fj{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fk{padding-left:1.5rem;}.ssr-plugin'
import '.fl{margin:1rem 0;}.ssr-plugin'
import '.fm{color:var(--gray-700);}.ssr-plugin'
import '.fn{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fj fk fl fm fn"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
